import { Link } from "react-router-dom";
import { Seo } from "@/components/site/Seo";
import { useLang } from "@/lib/i18n";

export default function NotFound() {
  const { t, to } = useLang();
  return (
    <section className="container-x py-32" data-testid="not-found">
      <Seo title="Page not found | Escamequita" description="This page could not be found." noindex />
      <p className="eyebrow">404</p>
      <h1 className="mt-3 text-5xl font-black text-forest">{t("nf.title")}</h1>
      <Link to={to("/")} className="btn-primary mt-8" data-testid="not-found-home">{t("nf.back")}</Link>
    </section>
  );
}
